export const classes = {
  title: 'font-bold text-xl text-grey-8 inline',
  subtitle: 'font-normal text-sm text-grey-7 inline',
  closeButtonWrapper: 'place-between',
  closeButtonTitles: 'flex flex-col',
  closeButton: 'text-grey-5',
  titles: 'pt-3 pb-6',
};
